const snackbarModule = {
    namespaced: true,
    persistent: true,
    state: {
        showSnackbar: false,
        message: null,
        color: null
    },
    mutations: {
        setSnackbar(state, payload) {
            state.showSnackbar = true;
            state.message = payload.message;
            state.color = payload.color;
        },
        resetSnackbar(state) {
            state.showSnackbar = false;
            state.message = null;
            state.color = null;
        }
    },
    getters: {
        isVisible: state => {
            return state.showSnackbar;
        },
        getMessage: state => {
            return state.message;
        },
        getColor: state => {
            return state.color;
        }
    }
};

export default snackbarModule;
